import {
  FadvMenuItemBase
} from "./chunk.QHZ3R2SE.js";
import {
  createPopper
} from "./chunk.A364I6JA.js";
import {
  animateTo,
  stopAnimations
} from "./chunk.JEYCYKK2.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  getAnimation,
  setDefaultAnimation
} from "./chunk.456HIP2G.js";
import {
  e,
  e2,
  i
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/menu-item/menu-item-submenu.ts
var FadvMenuItemSubmenu = class extends FadvMenuItemBase {
  constructor() {
    super(...arguments);
    this.hasSubmenuController = new HasSlotController(this, "submenu");
  }
  get hasSubmenu() {
    return this.hasSubmenuController.test("submenu");
  }
  get isHorizontal() {
    return this.classList.contains("menu-horizontal--menu-item");
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
    this.handleDocumentMousedown = this.handleDocumentMousedown.bind(this);
    document.addEventListener("keydown", this.handleDocumentKeydown);
    document.addEventListener("mousedown", this.handleDocumentMousedown);
  }
  disconnectedCallback() {
    this.destroySubmenuPopover();
    document.removeEventListener("keydown", this.handleDocumentKeydown);
    document.removeEventListener("mousedown", this.handleDocumentMousedown);
    super.disconnectedCallback();
  }
  handleClick(event) {
    if (this.hasSubmenu) {
      event.stopImmediatePropagation();
    }
  }
  handleSubItemSelect(event) {
    if (!this.hasSubmenu)
      return;
    if (hasTag(event.detail.item, "fadv-menu-item")) {
      this.closeSubmenu();
      event.stopImmediatePropagation();
    }
  }
  createSubmenuPopover() {
    this.popoverInstance = createPopper(this.base, this.positioner, {
      placement: "right-start",
      strategy: "fixed",
      modifiers: [
        {
          name: "flip",
          options: {
            boundary: "viewport",
            fallbackPlacements: ["bottom", "top", "left"]
          }
        }
      ]
    });
  }
  destroySubmenuPopover() {
    var _a;
    (_a = this.popoverInstance) == null ? void 0 : _a.destroy();
  }
  async handleExpandedChange() {
    var _a;
    if (!this.hasSubmenu)
      return;
    if (!this.submenuContainer)
      return;
    if (this.expanded) {
      await stopAnimations(this);
      this.createSubmenuPopover();
      (_a = this.popoverInstance) == null ? void 0 : _a.update();
      this.submenuContainer.hidden = false;
      const { keyframes, options } = getAnimation(this, "submenu.show");
      await animateTo(this.submenuContainer, keyframes, options);
      this.setAttribute("aria-expanded", "true");
    } else {
      await stopAnimations(this);
      const { keyframes, options } = getAnimation(this, "submenu.hide");
      await animateTo(this.submenuContainer, keyframes, options);
      this.submenuContainer.hidden = true;
      this.destroySubmenuPopover();
      this.setAttribute("aria-expanded", "false");
    }
  }
  closeSubmenu() {
    this.expanded = false;
    requestAnimationFrame(() => {
      this.setAttribute("tabindex", "0");
      this.focus();
    });
  }
  handleMouseenter(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.hasSubmenu)
      return;
    this.expanded = true;
  }
  handleMouseleave(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.hasSubmenu)
      return;
    this.expanded = false;
  }
  handleTouchend(event) {
    if (!this.hasSubmenu)
      return;
    if (hasTag(event.target, "fadv-menu-item") && event.target !== this)
      return;
    this.expanded = !this.expanded;
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  handleDocumentMousedown(e3) {
    if (!this.hasSubmenu)
      return;
    if (!e3.composedPath().includes(this)) {
      this.expanded = false;
    }
  }
  handleDocumentKeydown(e3) {
    if (!this.hasSubmenu)
      return;
    if (this.expanded && e3.key === "Escape") {
      this.closeSubmenu();
    }
  }
  handleSubmenuSlotChange() {
    this.setAttribute("aria-haspopup", "menu");
    this.setAttribute("aria-expanded", "false");
  }
  handleSubmenuSelection() {
    if (this.expanded) {
      this.closeSubmenu();
    }
    this.setAttribute("tabindex", "-1");
    this.expanded = true;
    requestAnimationFrame(() => {
      const menu = this.submenuSlot.assignedElements({ flatten: true })[0];
      const menuItems = (menu == null ? void 0 : menu.defaultSlot.assignedElements({ flatten: true })) || [];
      const menuItem = menuItems[0];
      menuItem.setAttribute("tabindex", "0");
      menuItem.focus();
    });
  }
  handleSubmenuClose(event) {
    if (!this.hasSubmenu)
      return;
    const closeHorizontal = this.isHorizontal && event.detail.key === "ArrowUp";
    const closeVertical = !this.isHorizontal && event.detail.key === "ArrowLeft";
    if (closeHorizontal || closeVertical) {
      this.closeSubmenu();
    }
  }
  renderSubmenu() {
    return $`<span class="menu-item__chevron"><fadv-icon name="chevron-right" library="default" aria-hidden="true"></fadv-icon></span><span part="submenu" @sl-select=${this.handleSubItemSelect} class="menu-item__submenu"><div class="menu-item__submenu-positioner"><div hidden class="menu-item__submenu-container"><slot name="submenu" @submenu-close=${this.handleSubmenuClose} @slotchange=${this.handleSubmenuSlotChange}></slot></div></div></span>`;
  }
};
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvMenuItemSubmenu.prototype, "expanded", 2);
__decorateClass([
  i(".menu-item")
], FadvMenuItemSubmenu.prototype, "base", 2);
__decorateClass([
  i(".menu-item__submenu-positioner")
], FadvMenuItemSubmenu.prototype, "positioner", 2);
__decorateClass([
  i(".menu-item__submenu-container")
], FadvMenuItemSubmenu.prototype, "submenuContainer", 2);
__decorateClass([
  i(".menu-item__submenu-container slot")
], FadvMenuItemSubmenu.prototype, "submenuSlot", 2);
__decorateClass([
  watch("expanded")
], FadvMenuItemSubmenu.prototype, "handleExpandedChange", 1);
__decorateClass([
  e2({ passive: true })
], FadvMenuItemSubmenu.prototype, "handleTouchend", 1);
setDefaultAnimation("submenu.show", {
  keyframes: [
    { opacity: 0, transform: "scale(0.9)" },
    { opacity: 1, transform: "scale(1)" }
  ],
  options: { duration: 150, easing: "ease" }
});
setDefaultAnimation("submenu.hide", {
  keyframes: [
    { opacity: 1, transform: "scale(1)" },
    { opacity: 0, transform: "scale(0.9)" }
  ],
  options: { duration: 150, easing: "ease" }
});

export {
  FadvMenuItemSubmenu
};
